<template>
    <div>
        <el-pagination
            background
            layout="sizes,total,prev, pager, next"
            @prev-click="pagerPrev"
            @next-click="pagerNext"
            @current-change="pagerCurrentChange"
            @size-change="handleSizeChange"
            :current-page="currentPage"
            :total="pagerTotal"
            :page-sizes="[10, 20, 50, 100, 500, 1000]"
            :page-size="pagerSize"
            v-if="pageshow"
        ></el-pagination>
    </div>
</template>
<script>
import AjaxHelper from '@/common/js/AjaxHelper'
export default {
    data() {
        return {
            pagerTotal: 0,
            pagerSize: 10,
            currentPage: 1,
            apiData: {},
            apiURLCanChange: this.apiURL,
            queryParamCanChange: this.queryParam,
            pageshow: true
        }
    },
    mounted: function () {
        if (this.isInit) {
            this.GetNewData()
        }
    },
    //GetData:抛出数据方法
    //apiURL:获取数据的API接口
    //queryParam：查询所用到的数据 Object
    //isInit:是否开始就抛出数据
    props: {
        GetData: {
            type: Function,
            required: true
        },
        errorFunc: {
            type: Function,
            required: false,
            default: function () {}
        },
        apiURL: {
            type: String,
            required: true
        },
        queryParam: {
            type: Object,
            required: true
        },
        isInit: {
            type: Boolean,
            required: false,
            default: true
        },
        beforeData: {
            type: Function,
            required: false,
            default: function () {}
        }
    },
    watch: {
        queryParam: {
            handler: function (newValue) {
                this.currentPage = 1
                this.queryParamCanChange = this.queryParam
                this.GetNewData()
            },
            deep: true
        }
    },
    methods: {
        Refresh() {
            //获取会议API
            const _this = this
            _this.GetNewData()
        },
        ChangeApiURL(apiURL, newqueryParam) {
            this.currentPage = 1
            this.apiURLCanChange = apiURL
            this.queryParamCanChange = newqueryParam
            this.GetNewData()
        },
        ChangeQueryParam(newqueryParam) {
            this.currentPage = 1
            this.queryParamCanChange = newqueryParam
            this.GetNewData()
        },
        GetNewData() {
            //获取会议API
            const _this = this
            _this.pageshow = false
            _this.beforeData()
            const MaxResultCount = _this.pagerSize
            const SkipCount = (_this.currentPage - 1) * _this.pagerSize
            // let queryJson = "";
            // if (!$.isEmptyObject(_this.queryParam)) {
            //   queryJson = JSON.stringify(_this.queryParam);
            // }
            let submit_data = {
                MaxResultCount: MaxResultCount,
                SkipCount: SkipCount
                // Filter: queryJson
            }
            Object.assign(submit_data, _this.queryParamCanChange)
            AjaxHelper.get(_this.apiURLCanChange, submit_data)
                .then(function (response) {
                    if (response.success) {
                        if (
                            response.result.items.length == 0 &&
                            _this.currentPage > 1
                        ) {
                            /*如果此次查询返回未返回集合数据 且不是第一页 则说明是删除了当前页的最后一条数据 
              页数减一并重新执行查询
              */
                            _this.currentPage = _this.currentPage - 1
                            _this.GetNewData()
                        } else {
                            _this.pagerTotal = response.result.totalCount
                            //结果赋值
                            _this.apiData = response.result.items
                            //抛出方法
                            _this.GetData(_this.apiData)
                        }
                    }
                })
                .catch(function (error) {
                    _this.errorFunc()
                })
            this.$nextTick(() => {
                this.pageshow = true
            })
        },
        pagerPrev(page) {
            this.currentPage = page
            this.GetNewData()
        },
        pagerNext(page) {
            this.currentPage = page
            this.GetNewData()
        },
        pagerCurrentChange(page) {
            this.currentPage = page
            this.GetNewData()
        },
        handleSizeChange(val) {
            this.currentPage = 1
            this.pagerSize = val
            this.GetNewData()
        }
    }
}
</script>
